(function () {
    const addToCart = document.querySelector("#add-to-cart")
    const productMultiple = document.querySelector(".product-multiple")
    const buyNowBtn = document.querySelector(".buy-now")
    const buyNowId = document.querySelector("#buy-now-id")
    let multiple = false
    let productMultipleInfo
    if (productMultiple) {
        productMultipleInfo = productMultiple.querySelector(".product-multiple-info")
    }

    //********* changing product in the cart *********//
    const updateItem = function (id, quantity) {
        const updatedCart = new DOMParser().parseFromString(`<div class="ring-loader"></div>`, "text/html")
        const loader = updatedCart.querySelector(".ring-loader")
        const cartItems = cartAjaxSection.querySelector(".cart__items")
        cartItems.replaceWith(loader)

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id, quantity}),
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 422) {
                        throw "Out of Stock!"
                    } else if (response.status === 404) {
                        throw "Can not find variant!"
                    } else {
                        throw "Something went wrong. Please reload the page!"
                    }
                }
            })
            .then((data) => {
                updateCart("cartajax", quantity)
                console.log("/cart/change.js", data)
            })

    }

    //********* add item in the cart *********//
    const addItem = function (id, quantity) {
        let request
        let relatedVariant = addToCart.dataset.relatedVariant
        if (relatedVariant === "") {
            request = JSON.stringify({
                items: [
                    {
                        id: Number(id),
                        quantity: quantity,
                    },
                ],
            })
        } else {
            request = JSON.stringify({
                items: [
                    {
                        id: Number(id),
                        quantity: quantity,
                    },
                    {
                        id: Number(relatedVariant),
                        quantity: 1
                    }
                ],
            })
        }

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: request,
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 422) {
                        throw "Out of Stock!"
                    } else if (response.status === 404) {
                        throw "Can not find variant!"
                    } else {
                        throw "Something went wrong. Please reload the page!"
                    }
                } else {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                }
                return response.json()
            })
            .then((data) => {
                console.log("/cart/add.js", data)
                document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        quantity: Number(quantity),
                        products: data.items
                    }
                }));
                addToCart.disabled = false
            })
            .catch((e) => {
                console.error("/cart/add.js", e)
            })
    }


    //********* Check product multiple *********//

    const checkMultiple = function () {
        if (addToCart.hasAttribute("data-multiple")) {
            let residue = addToCart.dataset.productQuantity % addToCart.dataset.multiple
            if (residue === 0) {
                buyNowQuantity.value = productQuantityValue.value
                multiple = false
            } else {
                productMultiple.classList.add("active")
                productMultipleInfo.classList.remove("hide")
                setTimeout(function () {
                    productMultiple.classList.remove("active")
                }, 800)

                multiple = true
            }
        } else {
            buyNowQuantity.value = productQuantityValue.value
            multiple = false
        }
    }

    //********* Check product multiple *********//

    /*********** check variant is selected **************/

    let checkVarSel = false
    const checkVariantIsSelected = () => {
        if (typeof variantIsSelected !== 'undefined') {
            if(!variantIsSelected) {
                let emptySelectContainer = $(selectContainer).has('[data-value="empty"]')
                let emptyTitle = $(".select-title__false")

                $(emptySelectContainer)[0].scrollIntoView({
                    behavior: "smooth",
                    block: "end"
                })

                $(emptySelectContainer).addClass("empty-variant-select")
                $(emptyTitle).addClass("empty-variant-title")
                setTimeout(() => {
                    $(emptySelectContainer).removeClass("empty-variant-select")
                    $(emptyTitle).removeClass("empty-variant-title")
                }, 800)
            } else {
                checkVarSel = true
            }
        } else {
            checkVarSel = true
        }
    }

    /***********/ /* check variant is selected **********/


    //********* Add to Cart button *********//

    if (addToCart) {
        addToCart.addEventListener("click", function (evt) {

            evt.preventDefault()
            let pointer = evt.target

            checkMultiple()
            checkVariantIsSelected()
            if (!multiple && checkVarSel) {
                addItem(pointer.dataset.productId, pointer.dataset.productQuantity)
            } else {
                evt.stopPropagation()
                addToCart.disabled = false
                buyNowBtn.disabled = false
            }
        })
    }

    //*********/ Add to Cart button *********//


    //********* Buy now button *********//

    if (buyNowBtn) {
        buyNowBtn.addEventListener("click", function (evt) {

            evt.preventDefault()
            let pointer = evt.target

            let id = pointer.dataset.productId
            let quantity = pointer.dataset.productQuantity
            let url = buyNowQuantity.dataset.shopUrl
            let cartUrl = ""

            let relatedVariant = pointer.dataset.relatedVariant
            if (relatedVariant !== "") {
                cartUrl = `https://${url}/cart/${id}:${quantity},${relatedVariant}:1`
            } else {
                cartUrl = `https://${url}/cart/${id}:${quantity}`
            }


            checkMultiple()
            checkVariantIsSelected()
            if (!multiple && checkVarSel) {
                window.location.href = cartUrl;
            }
        })
    }

    //*********/ Buy now button *********//


    //********* Wishlist *********//

    const wishlist = document.querySelector("#wishlist")

    if (wishlist) {
        wishlist.addEventListener("click", function (evt) {
            let pointer = evt.target

            if (pointer.classList.contains("addbutton")) {
                console.log(pointer);
                let quantity = 1
                // console.log(typeof pointer.dataset.multiple);
                if (pointer.dataset.multiple) {
                    quantity = pointer.dataset.multiple
                }
                console.log("quantity:", quantity);
                addItem(pointer.dataset.variantid, quantity)
            }
        })
    }
    //*********/ Wishlist *********//

})()
